import { useEffect, useState } from 'react';
import { Alert, Box, Link, Text } from '@nimbus-ds/components';
import { useNavegate } from 'App/hooks';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import { shippingRoutes } from 'domains/Shipping';
import usePhysicalLocations from 'domains/Shipping/DeliveryMethods/pages/DeliveryMethodsPage/components/PhysicalLocations/usePhysicalLocations';

export function PickupEmailItemCardAlert() {
  const { fetchPhysicalLocations, physicalLocations } = usePhysicalLocations();
  const [showAlert, setShowAlert] = useState(false);
  const { goTo } = useNavegate();
  const t = useTranslationConfigurations(
    'notifications.editNotificationPage.pickupEmailAlert',
  );

  useEffect(fetchPhysicalLocations, [fetchPhysicalLocations]);

  const handleOnRemove = () => {
    setShowAlert(false);
  };

  const handleOnClick = () => {
    goTo(shippingRoutes.SHIPPING_METHODS_BASE_ROUTE);
  };

  useEffect(() => {
    if (physicalLocations?.length) {
      setShowAlert(true);
    }
  }, [physicalLocations]);

  if (!physicalLocations?.length) {
    return null;
  }

  return (
    <Alert appearance="warning" show={showAlert} onRemove={handleOnRemove}>
      <Box display="flex" gap="2" flexDirection="column">
        <Text fontWeight="bold" color="warning-textLow">
          {t('title')}
        </Text>
        <Text>{t('description')}</Text>
      </Box>
      <Link onClick={handleOnClick}>{t('link')}</Link>
    </Alert>
  );
}
